<script>
import ChatLang from "./components/ChatLang.vue";
import ChatAca from "./components/ChatAca.vue";
export default {
    components: {
        ChatLang,
        ChatAca,
    },
    data() {
        return {
            ActiveTab: "",
            isActive: false,
        };
    },
    methods: {
        showBox() {
            this.isActive = !this.isActive;
        },
    },
    computed: {
        ag() {
            return this.$parent.ag;
        },
        wid() {
            return this.$parent.wid;
        },
        Setting() {
            return this.$parent.Settings;
        },
        Translation() {
            return this.$parent.Translation;
        },
        SetMascot() {
            if (this.ActiveTab == "academic") {
                if (this.Setting.MascotIdAca) {
                    return "background-image: url(https://studentpanel.net/widget/mascots/mascot-" + this.Setting.MascotIdAca + "-min.svg)";
                } else {
                    return "";
                }
            } else if (this.ActiveTab == "language") {
                if (this.Setting.MascotIdLang) {
                    return "background-image: url(https://studentpanel.net/widget/mascots/mascot-" + this.Setting.MascotIdLang + "-min.svg)";
                } else {
                    return "";
                }
            }
        },
    },
    mounted() {
        if (this.Setting.SearchMode === 0) {
            this.ActiveTab = "academic";
        } else if (this.Setting.SearchMode === 1) {
            this.ActiveTab = "language";
        } else if (this.Setting.SearchMode === 2) {
            this.ActiveTab = "academic";
        }

        if (this.Setting.ShowBar) {
            setTimeout(() => {
                this.isActive = true;
            }, 500);
        }
    },
};
</script>
<template>
    <div class="chat chat-cel">
        <button type="button" class="btn chat-button-circle" :class="{active: isActive}" @click="showBox">
            <span class="text-icon"></span>
            <span class="text">
                {{ this.Setting.Title }}
            </span>
        </button>
        <!-- <button type="button" class="btn chat-button" @click="showBox">Find your academic or language school</button> -->
        <div class="chat-container-circle" :class="{show: isActive}">
            <div class="chat-header">
                <h5 class="chat-header-title">
                    <template v-if="ActiveTab === 'language'">
                        {{ this.Setting.LangTitle }}
                    </template>
                    <template v-else-if="ActiveTab === 'academic'">
                        {{ this.Setting.AcaTitle }}
                    </template>
                </h5>
                <button type="button" class="btn btn-close" @click="showBox"></button>
            </div>
            <div class="chat-body">
                <div class="switch switch-full w-350" v-if="this.Setting.SearchMode === 0">
                    <button
                        type="button"
                        class="btn border-0 switch-item"
                        id="languageBox"
                        v-if="this.Setting.SearchMode === 0 || this.Setting.SearchMode == 1"
                        :class="{active: ActiveTab === 'language'}"
                        @click="ActiveTab = 'language'"
                    >
                        {{ this.Setting.LangSubTitle }}
                    </button>
                    <button
                        type="button"
                        class="btn border-0 switch-item"
                        id="academicBox"
                        v-if="this.Setting.SearchMode === 0 || this.Setting.SearchMode == 2"
                        :class="{active: ActiveTab === 'academic'}"
                        @click="ActiveTab = 'academic'"
                    >
                        {{ this.Setting.AcaSubTitle }}
                    </button>
                    <div class="switch-bg"></div>
                </div>
                <div class="tab-content-modal" id="tabContent">
                    <div
                        class="tab-pane fade"
                        :class="{'show active': ActiveTab == 'language' && (this.Setting.SearchMode === 0 || this.Setting.SearchMode == 1)}"
                        id="language-tab-pane"
                        role="tabpanel"
                        aria-labelledby="language-tab"
                        tabindex="0"
                    >
                        <ChatLang v-if="ActiveTab == 'language' && (this.Setting.SearchMode === 0 || this.Setting.SearchMode == 1)" />
                    </div>
                    <div
                        class="tab-pane fade"
                        :class="{'show active': ActiveTab == 'academic' && (this.Setting.SearchMode === 0 || this.Setting.SearchMode == 2)}"
                        id="academic-tab-pane"
                        role="tabpanel"
                        aria-labelledby="academic-tab"
                        tabindex="0"
                    >
                        <ChatAca v-if="ActiveTab == 'academic' && (this.Setting.SearchMode === 0 || this.Setting.SearchMode == 2)" />
                    </div>
                </div>
                <p class="fs-7 mb-0 lh-sm fw-500 mt-2 text-center">In partnership with</p>
                <img src="https://studentpanel.net/widget/icons/uniapplynow.png" alt="*" class="img-fluid mx-auto d-block" width="120" />
            </div>
        </div>
    </div>
</template>
